var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":this.destObj}},[_vm._v(" \n  "+_vm._s(_vm.prefix)+_vm._s(_vm.displayId)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }